// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "" + "js/vendors" + "." + "5d89ac5370907e2baa2e" + ".css";
};